import { type RefObject, useLayoutEffect, useState } from "react";
import { useStableCallback } from "../hooks/useStableCallback";

export const useResizeObserver = (element: RefObject<HTMLElement>) => {
  const [size, setSize] = useState<{ width: number; height: number } | null>(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: Refs should not be used as deps
  useLayoutEffect(() => {
    if (element.current) {
      const resizeObserver = new ResizeObserver(() => {
        if (element.current) {
          setSize({
            width: element.current?.offsetWidth,
            height: element.current?.offsetHeight,
          });
        } else {
          setSize(null);
        }
      });
      resizeObserver.observe(element.current);
      return () => resizeObserver.disconnect();
    }
  }, []);

  return size;
};

export const useResizeObserverEffect = (
  element: RefObject<HTMLElement>,
  callback: (width: number, height: number) => void
) => {
  const stableCallback = useStableCallback(callback);

  // biome-ignore lint/correctness/useExhaustiveDependencies: Ref and stableCallback should not be used as deps
  useLayoutEffect(() => {
    if (element.current) {
      const resizeObserver = new ResizeObserver(() => {
        if (element.current) {
          stableCallback(element.current.offsetWidth, element.current.offsetHeight);
        }
      });
      resizeObserver.observe(element.current);
      return () => resizeObserver.disconnect();
    }
  }, []);
};
